var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSlackLogo = function SvgSlackLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43235 0C7.16094 0.000937818 6.13197 1.03066 6.13291 2.29953C6.13197 3.5684 7.16188 4.59812 8.43329 4.59906H10.7337V2.30047C10.7346 1.0316 9.70469 0.00187564 8.43235 0C8.43329 0 8.43329 0 8.43235 0V0ZM8.43235 6.13333H2.29989C1.02848 6.13427 -0.00142541 7.164 -0.000485713 8.43286C-0.00236511 9.70173 1.02754 10.7315 2.29895 10.7333H8.43235C9.70375 10.7324 10.7337 9.70267 10.7327 8.4338C10.7337 7.164 9.70375 6.13427 8.43235 6.13333Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9998 8.43286C23.0008 7.164 21.9708 6.13427 20.6994 6.13333C19.428 6.13427 18.3981 7.164 18.3991 8.43286V10.7333H20.6994C21.9708 10.7324 23.0008 9.70267 22.9998 8.43286ZM16.8664 8.43286V2.29953C16.8674 1.0316 15.8384 0.00187564 14.567 0C13.2956 0.000937818 12.2657 1.03066 12.2666 2.29953V8.43286C12.2647 9.70173 13.2946 10.7315 14.566 10.7333C15.8374 10.7324 16.8674 9.70267 16.8664 8.43286Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5665 22.9999C15.8379 22.999 16.8678 21.9692 16.8669 20.7004C16.8678 19.4315 15.8379 18.4018 14.5665 18.4008H12.2661V20.7004C12.2652 21.9683 13.2951 22.998 14.5665 22.9999ZM14.5665 16.8656H20.6999C21.9713 16.8647 23.0012 15.835 23.0003 14.5661C23.0021 13.2972 21.9722 12.2675 20.7008 12.2656H14.5674C13.296 12.2666 12.2661 13.2963 12.2671 14.5652C12.2661 15.835 13.2951 16.8647 14.5665 16.8656Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42529e-07 14.5661C-0.000939053 15.835 1.02897 16.8647 2.30038 16.8657C3.57178 16.8647 4.60169 15.835 4.60075 14.5661V12.2666H2.30038C1.02897 12.2675 -0.000939053 13.2973 6.42529e-07 14.5661ZM6.1334 14.5661V20.6995C6.13152 21.9683 7.16142 22.9981 8.43283 22.9999C9.70424 22.999 10.7341 21.9693 10.7332 20.7004V14.568C10.7351 13.2991 9.70518 12.2694 8.43377 12.2675C7.16142 12.2675 6.13246 13.2973 6.1334 14.5661C6.1334 14.5661 6.1334 14.5671 6.1334 14.5661Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSlackLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slack-logo.ca67a30a718ced82ed95f072483d46d7.svg";